
<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",

  mounted() {
    //this.changeOrientation();   // for Tablet
  },

  methods: {
    //移动端横屏展示
    changeOrientation() {
      let {
        width,
        height
      } = document.documentElement.getBoundingClientRect();

      let root = document.querySelector("#app");
      if (width < height) {
        root.style.top = `${(height - width) / 2}px`;
        root.style.left = `${0 - (height - width) / 2}px`;
      }

      let kind =
          "onorientationchange" in window
              ? "orientationchange"
              : "resize";

      window.addEventListener(kind, () => {
        setTimeout(() => {
          let {
            width,
            height
          } = document.documentElement.getBoundingClientRect();

          let root = document.querySelector("#app");

          if (width > height) {
            root.style.top = 0;
            root.style.left = 0;
          } else {
            root.style.top = `${(height - width) / 2}px`;
            root.style.left = `${0 - (height - width) / 2}px`;
          }
        }, 200);
      });
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  height: 100%;
  font-size: 10vw;
}

body {
  width: 100%;
  height: 100%;
  font-family: Helvetica;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  display: flex;
  flex-direction: row;
}

@media screen and (orientation: portrait) {
  #app {
    /*  Always Landacape Mode
    height: 100vw;
    width: 100vh;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
    overflow: hidden;
*/

    /*  Normal Portrait Mode*/
    height: 100vh;
    width: 100vw;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);


  }
}

@media screen and (orientation: landscape) {
  #app {
    height: 100vh;
    width: 100vw;
    -webkit-transform: rotate(0);
    -moz-transform: rotate(0);
    -ms-transform: rotate(0);
    transform: rotate(0);
  }
}
</style>


<!--
<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
-->